// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"91":"SmartBannerFullScreen","260":"FavouritesUiDynamicBuyerInfoModal"}[chunkId] + ".mp." + {"91":"64d551a4","260":"85d3ec2d"}[chunkId] + ".css";
};